// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimPaymentBatchByIdIdPaymentBatchByIdResponse {
    static getAttributeTypeMap() {
        return ClaimV1ClaimPaymentBatchByIdIdPaymentBatchByIdResponse.attributeTypeMap;
    }
}
ClaimV1ClaimPaymentBatchByIdIdPaymentBatchByIdResponse.discriminator = undefined;
ClaimV1ClaimPaymentBatchByIdIdPaymentBatchByIdResponse.additionalProperties = false;
ClaimV1ClaimPaymentBatchByIdIdPaymentBatchByIdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ClaimPaymentBatchModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1ClaimPaymentBatchByIdIdPaymentBatchByIdResponse.js.map